import { ApiBase } from '../apiBase';
import { ApplicationPdf } from './models/ApplicationModels';

export class ApiPdf {
  public static applicationBaseUrl(): string {
    return `/pdf`;
  }

  public static async consumerCredentials(data: ApplicationPdf): Promise<{ blob: Blob; password?: string }> {
    const response = await ApiBase.post(`${this.applicationBaseUrl()}/consumer-credentials`, data, 'blob');
    const password = response.headers['pdf-password'];
        
    return {
      blob: response.data as Blob,
      password: password
    };
  }
}
